export default "__VITE_ASSET__5a2e08b6__"